var sortDirections = {};
function sortTable(columnIndex) {
  var table = document.getElementById('shoeTable');
  if (!table) return;
  
  var tbody = table.querySelector('tbody');
  var rows = Array.from(tbody.querySelectorAll('tr'));
  
  if (sortDirections[columnIndex] === undefined) {
    sortDirections[columnIndex] = true;
  } else {
    sortDirections[columnIndex] = !sortDirections[columnIndex];
  }
  var asc = sortDirections[columnIndex];

  rows.sort(function(rowA, rowB) {
    var cellA = rowA.children[columnIndex].textContent.trim();
    var cellB = rowB.children[columnIndex].textContent.trim();

    var valA = isNaN(cellA) || cellA === '' ? cellA.toLowerCase() : parseFloat(cellA);
    var valB = isNaN(cellB) || cellB === '' ? cellB.toLowerCase() : parseFloat(cellB);

    if (valA < valB) return asc ? -1 : 1;
    if (valA > valB) return asc ? 1 : -1;
    return 0;
  });

  rows.forEach(function(row) {
    tbody.appendChild(row);
  });
}